// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';

import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import Badge from '@cloudscape-design/components/badge';

const navHeaderUsers= { text: 'Usuarios', href: '#/' };
export const navItemsUsers: SideNavigationProps['items'] = [
  {
    type: 'section',
    text: 'Usuarios',
    items: [
      { type: 'link', text: 'Listado', href: '#/distributions3' },
      { type: 'link', text: 'Agregar', href: '#/cache' },
    ],
  },
  {
    type: 'section',
    text: 'Autorizaciones',
    items: [
      { type: 'link', text: 'Pendientes', href: '#/howto',
        info: <Badge color="blue">23</Badge>
       },
      { type: 'link', text: 'Expiradas', href: '#/origin1' },
    ],
  },
  {
    type: 'section',
    text: 'Restricciones',
    items: [
      { type: 'link', text: 'Asignaciones', href: '#/howto3' },
      { type: 'link', text: 'Políticas', href: '#/origin3', 
        info: <Badge color="red">23</Badge> },
    ],
  },
  {
    type: 'section',
    text: 'Geolocalizaciones',
    items: [
      { type: 'link', text: 'Accesos', href: '#/howto2' },
      { type: 'link', text: 'Unidades', href: '#/origin4' },
    ],
  },
];

const defaultOnFollowHandler: SideNavigationProps['onFollow'] = event => {
  // keep the locked href for our demo pages
  event.preventDefault();
};

interface NavigationProps {
  activeHref?: string;
  header?: SideNavigationProps['header'];
  items?: SideNavigationProps['items'];
  onFollowHandler?: SideNavigationProps['onFollow'];
}

export function NavigationUsers({
  activeHref,
  header = navHeaderUsers,
  items = navItemsUsers,
  onFollowHandler = defaultOnFollowHandler,
}: NavigationProps) {
  return <SideNavigation items={items} header={header} activeHref={activeHref} onFollow={onFollowHandler} />;
}
